<template>
  <div v-if="pageDevice != null && isLoginUserPageItemWritable">

    <deviceTabs :current="'upload'" :pageDevice="pageDevice" :pageUser="pageUser" />

    <div class="m-0 mt-3 mr-2" v-if="this.pageDevice.disabled == true">
      <b-alert class="m-0 mt-2 mb-2 p-1 pl-2 fontSizeDot9" show variant="danger">
        정지 중입니다.
      </b-alert>
    </div>

    <p class="mt-2 pt-0 gothic">
      팅커블 IoT 키트에서 data.tinkable.net에 데이터를 업로드하는 통신 방식에 대한 설명입니다. 팅커블 IoT 키트에서 데이터를 업로드하는 방식과 동일한 방법으로 업로드를 테스트해볼 수 있습니다.
    </p>

    <b-card no-body class="mt-3">
      <b-tabs pills card small variant="secondary" nav-class="p-0 m-0" nav-wrapper-class="p-1">

        <b-tab title="POST" active title-link-class="ml-2 pt-dot1 pb-dot1 pl-3 pr-3" class="m-0 p-2">
          <b-card-text class="p-0">

            <h4 @click="toggleCollapsed('form_howto')" class="cursor-pointer border-top border-bottom pt-2 pb-2">
              0. 주소와 데이터 형식
              <b-badge id="button_form_howto" class="float-right fontSizeDot9 cursor-pointer ml-2 mr-2" style="width: 1.3rem" @click.self.stop="toggleCollapsed('form_howto')">+</b-badge>
            </h4>
            <b-collapse id="collapse_form_howto">

              <p>아두이노나 다른 IoT 기기에서 데이터를 업로딩할 주소는 다음과 같습니다.</p>
              <p class="bg-secondary-lighter p-2" style="overflow : hidden">{{this.functionsServer + "/app/ad"}}</p>
              <p>
                IoT 기기에서 ID와 패스워드로 로그인하기는 힘들고 코드 안에 패스워드를 넣어두면 보안상 위험합니다. 그래서 data.tinkable.net에서는 ID, 패스워드 대신 접속코드를 사용합니다. 접속 코드는 기기마다 발급되며 유출된 경우에는 변경할 수 있습니다. 접속코드가 사용자 ID, 패스워드, 기기 ID를 모두 대신하므로 편리합니다. 다음은 이 기기의 접속 코드입니다.
              </p>
              <p class="bg-secondary-lighter p-2">{{this.acode}} </p>
              <p>
                HTTP POST는 전통적으로 application/x-www-form-urlencoded 형식으로 데이터를 전송합니다. 이 형식은 데이터를 '인자=값'과 같은 형태로 전송하는 방식입니다. IoT 기기에서 데이터를 전송할 때도 Content-Type 요청 헤더를 다음과 같이 application/x-www-form-urlencoded로 지정해야 합니다.
              </p>
              <p class="bg-secondary-lighter p-2">
                Content-Type: application/x-www-form-urlencoded
              </p>
              <p>데이터를 업로드할 때는 다음과 같이 acode, sensor, dt 또는 dtstr, response 인자를 사용합니다.</p>

              <ul class="mr-4">
                <li><b>acode</b>: 필수. 문자열. 접속 코드입니다. 이 기기의 접속 코드는<i>{{this.acode}}</i>입니다.</li>
                <li>
                  <b>sensor</b>: 필수. 문자열. 센서의 이름입니다. 이 기기에 등록된 센서의 이름에는 <span v-for="(item,index, position) in pageDevice.sensors" :key="item.id"><i>{{item.name}}</i><span v-if="position != (countAttributes(pageDevice.sensors)-1)">, </span></span>가 있습니다.
                </li>
                <li>
                  <b>dt</b>: 옵션. 숫자. 센서에서 데이터를 측정한 시간으로 유닉스 시간입니다. 그리니치(UTC) 기준으로 1970년 1월 1일 0시 0분 0초부터 몇 초를 경과했는 지를
                  나타내는 정수입니다. 지정하지 않으면 서버 시간을 사용합니다.
                </li>
                <li>
                  <b>dtstr</b>: 옵션. 문자열. 센서에서 데이터를 측정한 시간으로 "<i>YYYY</i>-<i>MM</i>-<i>DD</i><b>T</b><i>HH</i>:<i>mm</i>:<i>ss.sss</i>&PlusMinus;<i>HH</i>:<i>mm</i>"과 형식으로 된 문자열입니다. dt, dtstr을 모두 지정하면 dt가 우선합니다.
                </li>
                <li>
                  <b>response</b>: 옵션. 문자열. 데이터를 추가하고 응답을 어떤 형식으로 받을 지 지정합니다. <i>number</i>로 지정하면 성공이면 1, 실패면 0 미만의 정수를 text/plain 타입으로 돌려줍니다. <i>json</i>으로 지정하면 success, error, message 속성을 가진 json 개체를 application/json 타입으로 돌려줍니다. success는 성공이면 true를, error는 에러 번호를, message는 에러 내용 문자열입니다. 기본값은 number입니다. 기타 필요에 따라서 JSON 개체에 다른 속성이 추가될 수도 있습니다.
                </li>
              </ul>
              <p>새로 저장하는 데이터는 항상 저장된 데이터보다 나중의 것이어야 합니다. dt, dtstr 인자로 지정한 시간은
              저장된 시간과 같거나 그 이후여야 합니다.</p>
            </b-collapse>
            <div v-for="(item, index, position) in pageDeviceSensorsFiltered" :key="item.id">

              <h4 @click="toggleCollapsed('form_' + item.id)" class="cursor-pointer border-top border-bottom pt-2 pb-2">
                {{position+1}}. {{item.title}} ({{item.name}})
                <b-badge  class="float-right fontSizeDot9 cursor-pointer ml-2 mr-2" style="width: 1.3rem" variant="secondary" :id="'button_form_' + item.id" @click.self.stop="toggleCollapsed('form_' + item.id)">+</b-badge>
              </h4>

              <b-collapse :id="'collapse_form_' + item.id">
                <p>
                  {{item.name}} 센서는 다음과 같은 데이터를 전송합니다.
                </p>
                <ul class="mr-4">
                  <li v-for="(value, index) in item.values" :key="index">
                    <div v-if="!value.hold">
                      {{value.title}} : <b>{{value.name}}</b>를 인자로 사용하여 데이터를 보냅니다. 보내는 값은 {{value.type}} 형식입니다. <span v-if="typeof(value.unit) != 'undefined' && value.unit != ''">값의 단위는 {{value.unit}}입니다.</span> <span v-if="typeof(value.min) != 'undefined' && value.min != ''">값의 최대값은 {{value.min}}입니다.</span>  <span v-if="typeof(value.max) != 'undefined' && value.max != ''">값의 최대값은 {{value.max}}입니다.</span>
                    </div>
                    <div v-else style="text-decoration:line-through;">
                      {{value.title}} : <b>{{value.name}}</b>를 인자로 사용하여 데이터를 보냅니다. 보내는 값은 {{value.type}} 형식입니다. <span v-if="typeof(value.unit) != 'undefined' && value.unit != ''">값의 단위는 {{value.unit}}입니다.</span> <span v-if="typeof(value.min) != 'undefined' && value.min != ''">값의 최대값은 {{value.min}}입니다.</span>  <span v-if="typeof(value.max) != 'undefined' && value.max != ''">값의 최대값은 {{value.max}}입니다.</span>
                    </div>
                  </li>
                </ul>
                <p>
                    그럼 실제로 전송할 데이터를 한번 만들어 봅시다.
                    <b-button size="sm" style="padding: 0.2ex 1ex 0.2ex 1ex" variant="primary"
                    @click="makeUploadData('form', item.name)">1단계: 전송 데이터 만들기</b-button>
                    버튼을 누르면 전송할 데이터가 아래에 생성됩니다. 데이터는 인자=값과 같은 형식이며 값은 타입, 최소값, 최대값에 맞게 임의로 생성됩니다.
                  </p>
                  <p>
                    type이 boolean인 경우 전송 데이터가 0, false, "false", -1면 서버에서 false로, "1", 1, "true", true면 서버에서 true로 저장되므로 아래 텍스트 상자에도 이 중에 하나의 값으로 생성됩니다.
                  </p>
                  <p>
                    센서의 데이터 측정 시간을 나타내는 dt, dtstr 인자를 사용하지 않으면 저장 시점의 서버의 시간으로 저정합니다. 전송할 데이터를 생성할 때 임의로 dt, dtstr 인자 중에 하나가 만들어집니다.
                  </p>
                  <p>
                    응답의 형식을 지정하는 response는 number나 json이 가능합니다. 없으면 number를 기본값으로 사용합니다. 아래 데이터에서 줄바꿈, 인자의 이름, 등호 외에 나머지 값들은 직접 수정하셔도 됩니다.
                  </p>
                <div class="mr-2 ml-2 mt-1 mb-2">
                  <b-form-textarea v-touch:swipe.stop rows="3" v-model="toSend['form_' + item.name]" max-rows="20"></b-form-textarea>
                </div>
                <p>
                  데이터의 타입이 string인 경우 문자열에 =,&amp;가 들어가는 경우가 발생합니다. 즉 "인자=값&amp;...&amp;인자=값"과 같은 형식으로 전송하는 데 값 안에 =, ?가 들어가면 서버에서 데이터를 받아서 인자와 값들로 정확하게 나누어서 사용할 수 없습니다. 이런 문제 때문에 서버로 데이터를 전송하기 전에 값 안에 들어간 =, &amp;와 같은 문자를 다른 문자로 바꾸는 인코딩 과정을 거칩니다.
                </p>
                <p>
                  <b-button size="sm" style="padding: 0.2ex 1ex 0.2ex 1ex" variant="primary" @click="makeEncodedData('form', item.name)">2단계: 값을 인코딩한 후에 &amp;로 연결하기</b-button>
                  버튼을 누르면  위의 텍스트 입력 상자의 데이터 중에서 값을 인코딩 한 다음에 &amp; 문자를 사용하여 합칩니다.
                </p>
                <p>
                  모든 준비가 끝났으면 이제 서버로 데이터를 전송합니다.
                  <b-button size="sm" style="padding: 0.2ex 1ex 0.2ex 1ex" variant="primary" @click="makeRequest('form', item.name)">3단계: 서버로 데이터 업로딩하기</b-button>
                  버튼을 누르면 {{functionsServer + "/app/ad"}} 주소로 Content-Type 요청 헤더는 application/x-www-form-urlencoded으로 설정하고 본문은 위의 텍스트 입력 상자로 해서 POST 방식으로 요청을 보냅니다.
                  아래는 그 실행 결과입니다.
                </p>
                <p class="bg-secondary-lighter p-2" >{{toSend['form_result_' + item.name]}}</p>
                <p>
                  요청을 보낼 때 response 인자를 number로 지정한 경우에는 숫자로, json으로 지정한 경우에는 json 개체를 응답으로 돌려줍니다. number로 지정한 경우에 Content-Type 응답 헤더는 text/plain으로 사실 숫자가 아니라 문자열입니다. json으로 지정한 경우에는 Content-Type 응답 헤더는 application/json으로 위의 결과는 문자열로 변환한 것입니다. 아두이노와 같은 IoT 기기에서는 복잡한 응답 메시지를 처리하는 것이 부담이 됩니다. 따라서 요청을 보낼 때 response 인자를 number로 지정하고 응답으로 받은 문자열을 숫자로 변환하여 실행의 성공 여부만 판단하는 것이 좋습니다.
                </p>
              </b-collapse>
            </div>
          </b-card-text>
        </b-tab>

        <b-tab title="GET" title-link-class="pt-dot1 pb-dot1 pl-3 pr-3" class="m-0 p-2">
          <b-card-text class="p-0">
              <p>
                HTTP GET 방식은 요청 메시지의 본문이 아니라 주소에 ?, =을 사용하여 데이터를
                보냅니다. 사실 HTTP POST 방식은 데이터를 쓸(post) 때, GET 방식은 데이터를 가져올(get) 때
                사용합니다. 따라서 센서 데이터를 서버에 저장할 때는  GET 방식을 사용하는 것은
                좋지 않습니다. data.tinkable.net에서는 데이터 전송이 잘 되는 지 간단하게 테스트하기
                위해서 get 방식을 지원합니다.
              </p>
              <h4 @click="toggleCollapsed('get_howto')"  class="cursor-pointer border-top border-bottom pt-2 pb-2">
                0. 요청을 보낼 주소
                <b-badge  class="float-right fontSizeDot9 cursor-pointer ml-2 mr-2" style="width: 1.3rem" variant="secondary" id="button_get_howto" @click.self.stop="toggleCollapsed('get_howto')">+</b-badge>
              </h4>
              <b-collapse id="collapse_get_howto">
                <p>
                  get 방식은 요청할 페이지의 주소 다음에 ?를 사용하여 key=value&amp;key=value...&amp;key=value와 같은 형식으로 요청을 보냅니다. 다음은 접속 코드까지 포함한 요청을 보낼 주소입니다.
                </p>
                <p class="bg-secondary-lighter p-2">{{this.functionsServer + "/app/ad" + "?acode=" + this.acode}}</p>
                <p>이 다음에 동일하게 다음 key와 거기에 해당하는 value을 key=value 형태로 만들어서 &amp;로 연결해서 요청할 페이지의 주소를 만듭니다. key, value 안에 &amp;, = 이 사용될 수 있으므로 key, value는 인코딩합니다(encodeURIComponent).</p>
                <ul class="mr-4">
                  <li><b>acode</b>: 필수. 문자열. 접속 코드입니다. 이 기기의 접속 코드는<i>{{this.acode}}</i>입니다.</li>
                  <li>
                    <b>sensor</b>: 필수. 문자열. 센서의 이름입니다. 이 기기에 등록된 센서의 이름에는 <span v-for="(item,index, position) in pageDevice.sensors" :key="item.id"><i>{{item.name}}</i><span v-if="position != (countAttributes(pageDevice.sensors)-1)">, </span></span>가 있습니다.
                  </li>
                  <li>
                    <b>dt</b>: 옵션. 숫자. 센서에서 데이터를 측정한 시간으로 유닉스 시간입니다. 그리니치(UTC) 기준으로 1970년 1월 1일 0시 0분 0초부터 몇 초를 경과했는 지를
                    나타내는 정수입니다. 지정하지 않으면 서버 시간을 사용합니다.
                  </li>
                  <li>
                    <b>dtstr</b>: 옵션. 문자열. 센서에서 데이터를 측정한 시간으로 "<i>YYYY</i>-<i>MM</i>-<i>DD</i><b>T</b><i>HH</i>:<i>mm</i>:<i>ss.sss</i>&PlusMinus;<i>HH</i>:<i>mm</i>"과 형식으로 된 문자열입니다. dt, dtstr을 모두 지정하면 dt가 우선합니다.
                  </li>
                  <li>
                    <b>response</b>: 옵션. 문자열. 데이터를 추가하고 응답을 어떤 형식으로 받을 지 지정합니다. <i>number</i>로 지정하면 성공이면 1, 실패면 0 미만의 정수를 text/plain 타입으로 돌려줍니다. <i>json</i>으로 지정하면 success, error, message 속성을 가진 json 개체를 application/json 타입으로 돌려줍니다. success는 성공이면 true를, error는 에러 번호를, message는 에러 내용 문자열입니다. 기본값은 number입니다. 기타 필요에 따라서 JSON 개체에 다른 속성이 추가될 수도 있습니다.
                  </li>
                </ul>
                <p>새로 저장하는 데이터는 항상 저장된 데이터보다 나중의 것이어야 합니다. dt, dtstr 인자로 지정한 시간은 저장된 시간과 같거나 그 이후여야 합니다.</p>
              </b-collapse>
              <div v-for="(item, index, position) in pageDeviceSensorsFiltered" :key="item.id" class="mt-4">
                <h4 @click="toggleCollapsed('get_' + item.name)"  class="cursor-pointer border-top border-bottom pt-2 pb-2">
                  {{position+1}}. {{item.title}} ({{item.name}})
                  <b-badge  class="float-right fontSizeDot9 cursor-pointer ml-2 mr-2" style="width: 1.3rem" variant="secondary" :id="'button_get_' + item.name" @click.self.stop="toggleCollapsed('get_' + item.name)">+</b-badge>
                </h4>
                <b-collapse :id="'collapse_get_' + item.name">
                  <p>
                    {{item.name}} 센서는 다음과 같은 데이터를 전송합니다.
                  </p>
                  <ul class="mr-4">
                    <li v-for="(value, index) in item.values" :key="index">
                      <div v-if="!value.hold">
                        {{value.title}} : <b>{{value.name}}</b>를 이름으로 데이터를 보냅니다. 보내는 값은 {{value.type}} 형식입니다. <span v-if="typeof(value.unit) != 'undefined' && value.unit != ''">값의 단위는 {{value.unit}}입니다. </span> <span v-if="typeof(value.min) != 'undefined' && value.min != ''">값의 최대값은 {{value.min}}입니다. </span> <span v-if="typeof(value.max) != 'undefined' && value.max != ''">값의 최대값은 {{value.max}}입니다. </span>
                      </div>
                      <div v-else style="text-decoration: line-through;">
                        {{value.title}} : <b>{{value.name}}</b>를 이름으로 데이터를 보냅니다. 보내는 값은 {{value.type}} 형식입니다. <span v-if="typeof(value.unit) != 'undefined' && value.unit != ''">값의 단위는 {{value.unit}}입니다. </span> <span v-if="typeof(value.min) != 'undefined' && value.min != ''">값의 최대값은 {{value.min}}입니다. </span> <span v-if="typeof(value.max) != 'undefined' && value.max != ''">값의 최대값은 {{value.max}}입니다. </span>
                      </div>
                    </li>
                  </ul>
                    <p>
                      그럼 실제로 요청을 보낼 주소를 한번 만들어 봅시다.
                      <b-button size="sm" style="padding: 0.2ex 1ex 0.2ex 1ex" variant="primary"
                      @click="makeUploadData('get', item.name)">
                      1단계: 전송 주소 만들기
                      </b-button> 버튼을 누르면 요청을 보낼 주소가 만들어집니다.
                      데이터는 인자=값과 같은 형식이며 값은 타입, 최소값, 최대값에 맞게
                      임의로 생성됩니다.
                    </p>
                    <p>
                      type이 boolean인 경우 전송 데이터가 0, false, "false", -1면 서버에서 false로,
                      1, "true", true면 서버에서 true로 저장되므로 아래 텍스트 상자에도 이 중에 하나의
                      값으로 주소를 만듭니다.
                    </p>
                    <p>
                      센서의 데이터 측정 시간을 나타내는 dt, dtstr key를 사용하지 않으면
                      저장 시점의 서버의 시간으로 저정합니다. 전송할 데이터를 생성할 때 임의로
                      dt, dtstr key 중에 하나로 주소를 만듭니다.
                    </p>
                    <p>
                      응답의 형식을 지정하는 response는 number나 json이 가능합니다.
                      없으면 number를 기본값으로 사용합니다.
                  </p>
                  <div class="mr-2 ml-2 mt-1 mb-2">
                    <b-form-textarea v-touch:swipe.stop rows="3" v-model="toSend['get_' + item.name]" max-rows="20"></b-form-textarea>
                  </div>
                  <p>
                    <b-button size="sm" style="padding: 0.2ex 1ex 0.2ex 1ex" variant="primary"
                    @click="makeRequest('get', item.name)">
                    2단계: 이 주소를 요청하기
                    </b-button>버튼을 누르면
                    위의 주소르 GET 방식으로 요청을 보냅니다. GET 방식은 Content-Type 요청 헤더가
                    없으며, 요청 메시지의 본문도 없습니다. 아래는 그 실행 결과입니다.
                  </p>
                  <p class="bg-secondary-lighter p-2" >{{toSend['get_result_' + item.name]}}</p>
                  <p>
                    요청을 보낼 때 response key를 number로 지정한 경우에는 숫자로, json으로
                    지정한 경우에는 json 개체를 응답으로 돌려줍니다. number로 지정한 경우에
                    Content-Type 응답 헤더는 text/plain으로 사실 숫자가 아니라 문자열입니다.
                    json으로 지정한 경우에는 Content-Type 응답 헤더는 application/json으로
                    위의 결과는 문자열로 변환한 것입니다. 아두이노와 같은 IoT 기기에서는
                    복잡한 응답 메시지를 처리하는 것이 부담이 됩니다. 따라서 요청을 보낼 때
                    response key를 number로 지정하고 응답으로 받은 문자열을 숫자로 변환하여
                    실행의 성공 여부만 판단하는 것이 좋습니다.
                  </p>
                </b-collapse>
              </div>
          </b-card-text>
        </b-tab>

        <b-tab title="POST(JSON)" title-link-class="pt-dot1 pb-dot1 pl-3 pr-3" class="m-0 p-2">
          <b-card-text class="p-0">
            <p>POST 방식으로 데이터를 보내는 데 본문을 key=value&...&key=value 형식이 아니라 JSON 형식으로 보낼 수도 있습니다.</p>
            <h4 @click="toggleCollapsed('json_howto')"  class="cursor-pointer border-top border-bottom pt-2 pb-2">
              0. 업로딩 할 주소와 데이터 형식
              <b-badge  class="float-right fontSizeDot9 cursor-pointer ml-2 mr-2" style="width: 1.3rem" variant="secondary" id="button_json_howto" @click.self.stop="toggleCollapsed('json_howto')">+</b-badge>
            </h4>
            <b-collapse id="collapse_json_howto">
              <p>아두이노나 다른 IoT 기기에서 데이터를 업로딩할 주소는 다음과 같습니다.</p>
              <p class="bg-secondary-lighter p-2" style="overflow : hidden">{{this.functionsServer + "/app/ad"}}</p>
              <p>
                IoT 기기에서 ID와 패스워드로 로그인하기는 힘들고 코드 안에 패스워드를 넣어두면 보안상 위험합니다. 그래서 data.tinkable.net에서는 ID, 패스워드 대신 접속코드를 사용합니다. 접속 코드는 기기마다 발급되며 유출된 경우에는 변경할 수 있습니다. 접속코드가 사용자 ID, 패스워드, 기기 ID를 모두 대신하므로 편리합니다. 다음은 이 기기의 접속 코드입니다.
              </p>
              <p class="bg-secondary-lighter p-2">{{this.acode}} </p>
              <p>
                HTTP POST는 전통적으로 application/x-www-form-urlencoded Mime Type으로 지정한 key=value 형식으로 데이터를 전송하지만 JSON 방식은 Mime Type으로 application/json을 사용하고 요청의 본문으로 문자열로 변환한 JSON 개체를 보냅니다.
              </p>
              <p class="bg-secondary-lighter p-2">
                Content-Type: application/json
              </p>
              <p>
                JSON 개체는 다음과 같은 형식으로 되어 있습니다.
              </p>
              <pre class="bg-secondary-lighter p-2" style="white-space: pre-wrap !important;">
{
&nbsp;&nbsp;&nbsp;&nbsp;&quot;<b>acode</b>&quot;: &quot;<i>접속코드</i>&quot;,
&nbsp;&nbsp;&nbsp;&nbsp;&quot;<b>response</b>&quot;:&quot;<i>number|json</i>&quot;,
&nbsp;&nbsp;&nbsp;&nbsp;&quot;<b>sensor</b>&quot;:&quot;<i>센서이름</i>&quot;,
&nbsp;&nbsp;&nbsp;&nbsp;&quot;<b>values</b>&quot;: { &quot;dt&quot;: <i>unixEpochTime</i> | &quot;dtstr&quot;: &quot;<i>YYYY</i>-<i>MM</i>-<i>DD</i><b>T</b><i>HH</i>:<i>mm</i>:<i>ss.sss</i>&PlusMinus;<i>HH</i>:<i>mm</i>&quot;,<i> ...</i> }
}
</pre>
              <p>
                JSON 개체는 acode, response, sensor, values 속성을 가지고 있습니다. 그리고 <i>...data ...</i> 부분은 센서에서 지정한 값의 이름으로 센서마다 다릅니다.
              </p>
              <ul class="mr-4">
                <li><b>acode</b>: 필수. 문자열. 접속 코드입니다. 이 기기의 접속 코드는<i>{{this.acode}}</i>입니다.</li>
                <li>
                  <b>response</b>: 옵션. 문자열. 데이터를 추가하고 응답을 어떤 형식으로 받을 지 지정합니다. <i>number</i>로 지정하면 성공이면 1, 실패면 0 미만의 정수를 text/plain 타입으로 돌려줍니다. <i>json</i>으로 지정하면 success, error, message 속성을 가진 json 개체를 application/json 타입으로 돌려줍니다. success는 성공이면 true를, error는 에러 번호를, message는 에러 내용 문자열입니다. 기본값은 number입니다. 기타 필요에 따라서 JSON 개체에 다른 속성이 추가될 수도 있습니다.
                </li>
                <li><b>sensor</b>: 센서의 이름입니다.</li>
                <li>
                  <div><b>values</b>: 데이터를 담고 있는 속성입니다. 개체일 수도 있고 배열일 수도 있습니다.</div>
                </li>
              </ul>
              <p>
                JSON 개체의 values 속성은 개체일 수도 있고 배열일 수도 있습니다. 하나의 센서의 하나의 데이터 줄을 업로딩하는 경우에는 values 속성인 개체이지만, 여러 데이터를 한꺼번에 업로딩하는 경우에는 values 속성은 개체를 항목으로 하는 배열입니다.
              </p>
              <pre class="bg-secondary-lighter p-2">
{
&nbsp;&nbsp;&nbsp;&nbsp;&quot;<b>acode</b>&quot;: &quot;<i>접속코드</i>&quot;,
&nbsp;&nbsp;&nbsp;&nbsp;&quot;<b>response</b>&quot;:&quot;<i>number|json</i>&quot;,
&nbsp;&nbsp;&nbsp;&nbsp;&quot;<b>sensor</b>&quot;: &quot;<i>센서이름</i>&quot;,
&nbsp;&nbsp;&nbsp;&nbsp;&quot;<b>values</b>&quot;: [
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{ &quot;dt&quot;: <i>unixEpochTime</i> | &quot;dtstr&quot;: &quot;<i>YYYY</i>-<i>MM</i>-<i>DD</i><b>T</b><i>HH</i>:<i>mm</i>:<i>ss.sss</i>&PlusMinus;<i>HH</i>:<i>mm</i>&quot;,<i> ...</i> },
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{ &quot;dt&quot;: <i>unixEpochTime</i> | &quot;dtstr&quot;: &quot;<i>YYYY</i>-<i>MM</i>-<i>DD</i><b>T</b><i>HH</i>:<i>mm</i>:<i>ss.sss</i>&PlusMinus;<i>HH</i>:<i>mm</i>&quot;,<i> ...</i> },
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;... ... ...,
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{ &quot;dt&quot;: <i>unixEpochTime</i> | &quot;dtstr&quot;: &quot;<i>YYYY</i>-<i>MM</i>-<i>DD</i><b>T</b><i>HH</i>:<i>mm</i>:<i>ss.sss</i>&PlusMinus;<i>HH</i>:<i>mm</i>&quot;,<i> ...</i> }
&nbsp;&nbsp;&nbsp;&nbsp;]
}
</pre>
              <p>
                업로드하는 데이터는 저장된 데이터보다 시간이 같거나 늦어야 합니다.
                또한 한꺼번에 여러 개의 데이터를 지정할 때는 센서 별로 뒤에 오는 데이터가
                시간이 같거나 늦어야 합니다. 저장된 데이터나 앞의 데이터보다 빠른 데이터는
                버려집니다.
              </p>
            </b-collapse>
            <div v-for="(item, index, position) in pageDeviceSensorsFiltered" :key="item.name"  class="mt-4">
              <h4 @click="toggleCollapsed(item.name)"  class="cursor-pointer border-top border-bottom pt-2 pb-2">
                {{position+1}}. {{item.title}} ({{item.name}})
                <b-badge  class="float-right fontSizeDot9 cursor-pointer ml-2 mr-2" style="width: 1.3rem" variant="secondary" :id="'button_' + item.name" @click.self.stop="toggleCollapsed(item.name)">+</b-badge>
              </h4>
              <b-collapse :id="'collapse_' + item.name">
                <p>
                  {{item.name}} 센서는 다음과 같은 데이터를 전송합니다.
                </p>
                <ul class="mr-4">
                  <li v-for="(value, index) in item.values" :key="index">
                    <div v-if="!value.hold">
                      {{value.title}} : <b>{{value.name}}</b>를 이름으로 데이터를 보냅니다. 보내는 값은 {{value.type}} 형식입니다. <span v-if="typeof(value.unit) != 'undefined' && value.unit != ''">값의 단위는 {{value.unit}}입니다. </span> <span v-if="typeof(value.min) != 'undefined' && value.min != ''">값의 최대값은 {{value.min}}입니다. </span> <span v-if="typeof(value.max) != 'undefined' && value.max != ''">값의 최대값은 {{value.max}}입니다. </span>
                    </div>
                    <div v-else style="text-decoration: line-through;">
                      {{value.title}} : <b>{{value.name}}</b>를 이름으로 데이터를 보냅니다. 보내는 값은 {{value.type}} 형식입니다. <span v-if="typeof(value.unit) != 'undefined' && value.unit != ''">값의 단위는 {{value.unit}}입니다. </span> <span v-if="typeof(value.min) != 'undefined' && value.min != ''">값의 최대값은 {{value.min}}입니다. </span> <span v-if="typeof(value.max) != 'undefined' && value.max != ''">값의 최대값은 {{value.max}}입니다. </span>
                    </div>
                    </li>



                  </ul>
                  <p>
                    그럼 실제로 전송할 데이터를 한번 만들어 봅시다.
                    <b-button size="sm" class="pt-dot1 pb-dot1 fontSizeDot9" style="vertical-align: top !important" variant="primary"
                    @click="makeUploadData('json', item.name)">
                    1단계: 전송 데이터 만들기
                    </b-button> 버튼을 누르면 전송할 데이터가 아래에 생성됩니다.
                    전송할 데이터는 JSON 개체 형식입니다. 데이터 값은 타입, 최소값, 최대값에 맞게
                    임의로 생성됩니다.
                  </p>
                  <p>
                    type이 boolean인 경우 전송 데이터가 0, false, "false", -1면 서버에서 false로,
                    1, "true", true면 서버에서 true로 저장되므로 아래 텍스트 상자에도 이 중에 하나의
                    값으로 생성됩니다.
                  </p>
                  <p>
                    센서의 데이터 측정 시간을 나타내는 dt, dtstr 인자를 사용하지 않으면
                    저장 시점의 서버의 시간으로 저정합니다. 전송할 데이터를 생성할 때 임의로
                    dt, dtstr 인자 중에 임의로 하나를 사용합니다.
                  </p>
                  <p>
                    응답의 형식을 지정하는 response는 number나 json이 가능합니다.
                    없으면 number를 기본값으로 사용합니다.
                    아래 데이터를 직접 수정하셔도 됩니다.
                  </p>
                  <div class="mr-2 ml-2 mt-1 mb-2">
                    <b-form-textarea v-touch:swipe.stop rows="3" v-model="toSend['json_' + item.name]" max-rows="20"></b-form-textarea>
                  </div>
                  <p>
                    모든 준비가 끝났으면 이제 서버로 데이터를 전송합니다.
                    <b-button size="sm" style="padding: 0.2ex 1ex 0.2ex 1ex" variant="primary"
                    @click="makeRequest('json', item.name)">
                    2단계: 서버로 데이터 업로딩하기
                    </b-button>버튼을 누르면
                    {{functionsServer + "/app/ad"}} 주소로
                    Content-Type 요청 헤더는 application/json으로 설정하고
                    본문은 위의 텍스트 입력 상자로 해서 POST 방식으로 요청을 보냅니다.
                    아래는 그 실행 결과입니다.
                  </p>
                  <p class="bg-secondary-lighter p-2" >{{toSend['json_result_' + item.name]}}</p>
                  <p>
                    요청을 보낼 때 response 인자를 number로 지정한 경우에는 숫자로, json으로 지정한 경우에는 json 개체를 응답으로 돌려줍니다. number로 지정한 경우에 Content-Type 응답 헤더는 text/plain으로 사실 숫자가 아니라 문자열입니다. json으로 지정한 경우에는 Content-Type 응답 헤더는 application/json으로 위의 결과는 문자열로 변환한 것입니다. 아두이노와 같은 IoT 기기에서는 복잡한 응답 메시지를 처리하는 것이 부담이 됩니다. 따라서 요청을 보낼 때 response 인자를 number로 지정하고 응답으로 받은 문자열을 숫자로 변환하여 실행의 성공 여부만 판단하는 것이 좋습니다.
                  </p>
                  <p>
                    json 형식으로 데이터를 보낼 때는 여러 개의 데이터를 한꺼번에 보낼 수도 있습니다. 한꺼번에 보낼 수 있는 데이터 줄 수는 10000개까지입니다.
                    <b-button size="sm" style="padding: 0.2ex 1ex 0.2ex 1ex" variant="primary"
                    @click="makeUploadData('json_list', item.name)">
                    1단계: 여러 개의 전송 데이터 만들기
                  </b-button> 버튼을 누르면 1개에서 5개 사이에서 한꺼번에 전송 데이터를 만듭니다.
                  </p>
                  <div class="mr-2 ml-2 mt-1 mb-2">
                    <b-form-textarea v-touch:swipe.stop rows="3" v-model="toSend['json_list_' + item.name]" max-rows="20"></b-form-textarea>
                  </div>
                  <p>
                    전송 데이터를 생성했으면 이제 서버로 데이터를 전송합니다.
                    <b-button size="sm" style="padding: 0.2ex 1ex 0.2ex 1ex" variant="primary"
                    @click="makeRequest('json_list', item.name)">
                    2단계: 서버로 여러 개의 전송 데이터 한꺼번에 업로딩하기
                    </b-button>버튼을 누르면
                    {{functionsServer + "/app/ad"}} 주소로
                    Content-Type 요청 헤더는 application/json으로 설정하고
                    본문은 위의 텍스트 입력 상자로 해서 POST 방식으로 요청을 보냅니다.
                    아래는 그 실행 결과입니다.
                  </p>
                  <p class="bg-secondary-lighter p-2" >{{toSend['json_list_result_' + item.name]}}</p>
                </b-collapse>
            </div>
          </b-card-text>
        </b-tab>

        <b-tab title="POST(JSON, MULTIPLE)" title-link-class="pt-dot1 pb-dot1 pl-3 pr-3" class="m-0 p-2">
          <b-card-text class="p-0">
              <p> POST, JSON 방식으로 여러 센서에 대한 데이터를 한꺼번에 보낼 수도 있습니다. 아두이노나 다른 IoT 기기에서 데이터를 업로딩할 주소는 다음과 같이 ad가 아니라 ads로 끝납니다.</p>
              <p class="bg-secondary-lighter p-2" style="overflow : hidden">{{this.functionsServer + "/app/ads"}}</p>
              <p>
                IoT 기기에서 ID와 패스워드로 로그인하기는 힘들고 코드 안에 패스워드를 넣어두면 보안상 위험합니다. 그래서 data.tinkable.net에서는 ID, 패스워드 대신 접속코드를 사용합니다. 접속 코드는 기기마다 발급되며 유출된 경우에는 변경할 수 있습니다. 접속코드가 사용자 ID, 패스워드, 기기 ID를 모두 대신하므로 편리합니다. 다음은 이 기기의 접속 코드입니다.
              </p>
              <p class="bg-secondary-lighter p-2">{{this.acode}} </p>
              <p>
                HTTP POST는 전통적으로 application/x-www-form-urlencoded Mime Type으로 지정한 key=value 형식으로 데이터를 전송하지만 JSON 방식은 Mime Type으로 application/json을 사용하고 요청의 본문으로 문자열로 변환한 JSON 개체를 보냅니다.
              </p>
              <p class="bg-secondary-lighter p-2">
                Content-Type: application/json
              </p>
              <p>
                JSON 개체는 다음과 같은 형식으로 되어 있습니다.
              </p>
              <pre class="bg-secondary-lighter p-2">
{
&nbsp;&nbsp;&nbsp;&nbsp;&quot;<b>acode</b>&quot;: &quot;<i>접속코드</i>&quot;,
&nbsp;&nbsp;&nbsp;&nbsp;&quot;<b>response</b>&quot;:&quot;<i>number|json</i>&quot;,
&nbsp;&nbsp;&nbsp;&nbsp;&quot;<b>sensors</b>&quot;: [
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&quot;<b>sensor</b>&quot;:&quot;<i>센서이름</i>&quot;,
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&quot;<b>values</b>&quot;: { &quot;dt&quot;: <i>unixEpochTime</i> | &quot;dtstr&quot;: &quot;<i>YYYY</i>-<i>MM</i>-<i>DD</i><b>T</b><i>HH</i>:<i>mm</i>:<i>ss.sss</i>&PlusMinus;<i>HH</i>:<i>mm</i>&quot;,<i> ...</i> }
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;},
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;... ... ...,
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&quot;<b>sensor</b>&quot;:&quot;<i>센서이름</i>&quot;,
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&quot;<b>values</b>&quot;: { &quot;dt&quot;: <i>unixEpochTime</i> | &quot;dtstr&quot;: &quot;<i>YYYY</i>-<i>MM</i>-<i>DD</i><b>T</b><i>HH</i>:<i>mm</i>:<i>ss.sss</i>&PlusMinus;<i>HH</i>:<i>mm</i>&quot;,<i> ...</i> }
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;},
&nbsp;&nbsp;&nbsp;&nbsp;]
}
</pre>
              <p>
                JSON 개체는 acode, response, sensors, sensor, values 속성을 가지고 있습니다. 그리고 <i>...data ...</i> 부분은 센서에서 지정한 값의 이름으로 센서마다 다릅니다.
              </p>
              <ul class="mr-4">
                <li><b>acode</b>: 필수. 문자열. 접속 코드입니다. 이 기기의 접속 코드는<i>{{this.acode}}</i>입니다.</li>
                <li>
                  <b>response</b>: 옵션. 문자열. 데이터를 추가하고 응답을 어떤 형식으로 받을 지 지정합니다. <i>number</i>로 지정하면 성공이면 1, 실패면 0 미만의 정수를 text/plain 타입으로 돌려줍니다. <i>json</i>으로 지정하면 success, error, message 속성을 가진 json 개체를 application/json 타입으로 돌려줍니다. success는 성공이면 true를, error는 에러 번호를, message는 에러 내용 문자열입니다. 기본값은 number입니다. 기타 필요에 따라서 JSON 개체에 다른 속성이 추가될 수도 있습니다.
                </li>
                <li>
                  <b>sensors</b>: 필수. 개체를 항목으로 하는 배열입니다. sensor, values 속성을 가진 개체를 항목으로 지정합니다.
                </li>
                <li><b>sensor</b>: 센서의 이름입니다.</li>
                <li>
                  <div><b>values</b>: 데이터를 담고 있는 속성입니다. 개체일 수도 있고 배열일 수도 있습니다.</div>
                </li>
              </ul>
              <p>
                JSON 개체의 values 속성은 개체일 수도 있고 배열일 수도 있습니다. 여러 데이터를 한꺼번에 업로딩하는 경우에는 values 속성은 개체를 항목으로 하는 배열입니다.
              </p>
              <pre class="bg-secondary-lighter p-2">
{
&nbsp;&nbsp;&nbsp;&nbsp;&quot;<b>acode</b>&quot;: &quot;<i>접속코드</i>&quot;,
&nbsp;&nbsp;&nbsp;&nbsp;&quot;<b>response</b>&quot;:&quot;<i>number|json</i>&quot;,
&nbsp;&nbsp;&nbsp;&nbsp;&quot;<b>sensors</b>&quot;: [
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&quot;<b>sensor</b>&quot;:&quot;<i>센서이름</i>&quot;,
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&quot;<b>values</b>&quot;: [
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{ &quot;dt&quot;: <i>unixEpochTime</i> | &quot;dtstr&quot;: &quot;<i>YYYY</i>-<i>MM</i>-<i>DD</i><b>T</b><i>HH</i>:<i>mm</i>:<i>ss.sss</i>&PlusMinus;<i>HH</i>:<i>mm</i>&quot;,<i> ...</i> },
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{ &quot;dt&quot;: <i>unixEpochTime</i> | &quot;dtstr&quot;: &quot;<i>YYYY</i>-<i>MM</i>-<i>DD</i><b>T</b><i>HH</i>:<i>mm</i>:<i>ss.sss</i>&PlusMinus;<i>HH</i>:<i>mm</i>&quot;,<i> ...</i> },
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;... ... ...,
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{ &quot;dt&quot;: <i>unixEpochTime</i> | &quot;dtstr&quot;: &quot;<i>YYYY</i>-<i>MM</i>-<i>DD</i><b>T</b><i>HH</i>:<i>mm</i>:<i>ss.sss</i>&PlusMinus;<i>HH</i>:<i>mm</i>&quot;,<i> ...</i> }
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;]
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;},
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;... ... ...,
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&quot;<b>sensor</b>&quot;:&quot;<i>센서이름</i>&quot;,
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&quot;<b>values</b>&quot;: [
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{ &quot;dt&quot;: <i>unixEpochTime</i> | &quot;dtstr&quot;: &quot;<i>YYYY</i>-<i>MM</i>-<i>DD</i><b>T</b><i>HH</i>:<i>mm</i>:<i>ss.sss</i>&PlusMinus;<i>HH</i>:<i>mm</i>&quot;,<i> ...</i> },
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{ &quot;dt&quot;: <i>unixEpochTime</i> | &quot;dtstr&quot;: &quot;<i>YYYY</i>-<i>MM</i>-<i>DD</i><b>T</b><i>HH</i>:<i>mm</i>:<i>ss.sss</i>&PlusMinus;<i>HH</i>:<i>mm</i>&quot;,<i> ...</i> },
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;... ... ...,
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{ &quot;dt&quot;: <i>unixEpochTime</i> | &quot;dtstr&quot;: &quot;<i>YYYY</i>-<i>MM</i>-<i>DD</i><b>T</b><i>HH</i>:<i>mm</i>:<i>ss.sss</i>&PlusMinus;<i>HH</i>:<i>mm</i>&quot;,<i> ...</i> }
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;]
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;}
&nbsp;&nbsp;&nbsp;&nbsp;]
}
</pre>
              <p>
                업로드하는 데이터는 저장된 데이터보다 시간이 같거나 늦어야 합니다.
                또한 한꺼번에 여러 개의 데이터를 지정할 때는 센서 별로 뒤에 오는 데이터가
                시간이 같거나 늦어야 합니다. 저장된 데이터나 앞의 데이터보다 빠른 데이터는
                버려집니다.
              </p>
              <p>
                그럼 실제로 전송할 데이터를 한번 만들어 봅시다.
                <b-button size="sm" class="pt-dot1 pb-dot1 fontSizeDot9" style="vertical-align: top !important" variant="primary"
                @click="makeUploadData('jsons')">
                1단계: 전송 데이터 만들기
                </b-button> 버튼을 누르면 전송할 데이터가 아래에 생성됩니다.
                전송할 데이터는 JSON 개체 형식입니다. 데이터 값은 타입, 최소값, 최대값에 맞게
                임의로 생성됩니다.
              </p>
              <p>
                type이 boolean인 경우 전송 데이터가 0, false, "false", -1면 서버에서 false로,
                1, "true", true면 서버에서 true로 저장되므로 아래 텍스트 상자에도 이 중에 하나의
                값으로 생성됩니다.
              </p>
              <p>
                센서의 데이터 측정 시간을 나타내는 dt, dtstr 인자를 사용하지 않으면
                저장 시점의 서버의 시간으로 저정합니다. 전송할 데이터를 생성할 때 임의로
                dt, dtstr 인자 중에 임의로 하나를 사용합니다.
              </p>
              <p>
                응답의 형식을 지정하는 response는 number나 json이 가능합니다.
                없으면 number를 기본값으로 사용합니다.
                아래 데이터를 직접 수정하셔도 됩니다.
              </p>
              <div class="mr-2 ml-2 mt-1 mb-2">
                <b-form-textarea v-touch:swipe.stop rows="3" v-model="toSend['jsons']" max-rows="20"></b-form-textarea>
              </div>
              <p>
                모든 준비가 끝났으면 이제 서버로 데이터를 전송합니다.
                <b-button size="sm" style="padding: 0.2ex 1ex 0.2ex 1ex" variant="primary"
                @click="makeRequest('jsons')">
                2단계: 서버로 데이터 업로딩하기
                </b-button>버튼을 누르면
                {{functionsServer + "/app/ads"}} 주소로
                Content-Type 요청 헤더는 application/json으로 설정하고
                본문은 위의 텍스트 입력 상자로 해서 POST 방식으로 요청을 보냅니다.
                아래는 그 실행 결과입니다.
              </p>
              <p class="bg-secondary-lighter p-2" >{{toSend['jsons_result']}}</p>
              <p>
                json 형식으로 데이터를 보낼 때는 여러 개의 데이터를 한꺼번에 보낼 수도 있습니다. 한꺼번에 보낼 수 있는 데이터 줄 수는 10000개까지입니다.
                <b-button size="sm" style="padding: 0.2ex 1ex 0.2ex 1ex" variant="primary"
                @click="makeUploadData('jsons_list')">
                1단계: 여러 개의 전송 데이터 만들기
              </b-button> 버튼을 누르면 1개에서 5개 사이에서 한꺼번에 전송 데이터를 만듭니다.
              </p>
              <div class="mr-2 ml-2 mt-1 mb-2">
                <b-form-textarea v-touch:swipe.stop rows="3" v-model="toSend['jsons_list']" max-rows="20"></b-form-textarea>
              </div>
              <p>
                전송 데이터를 생성했으면 이제 서버로 데이터를 전송합니다.
                <b-button size="sm" style="padding: 0.2ex 1ex 0.2ex 1ex" variant="primary"
                @click="makeRequest('jsons_list')">
                2단계: 서버로 여러 개의 전송 데이터 한꺼번에 업로딩하기
                </b-button>버튼을 누르면
                {{functionsServer + "/app/ads"}} 주소로
                Content-Type 요청 헤더는 application/json으로 설정하고
                본문은 위의 텍스트 입력 상자로 해서 POST 방식으로 요청을 보냅니다.
                아래는 그 실행 결과입니다.
              </p>
              <p class="bg-secondary-lighter p-2" >{{toSend['jsons_list_result']}}</p>
          </b-card-text>
        </b-tab>

        <b-tab title="POST(CSV)" title-link-class="pt-dot1 pb-dot1 pl-3 pr-3" class="m-0 p-2">
          <b-card-text class="p-0">
            <p>POST 방식으로 데이터를 보낼 때 본문에는 CSV 형식의 데이터를 그대로 넣고 주소에 acode, sensor와 같은 값을 넣어줄 수도 있습니다. 이 방식은 센서에서 측정한 값을 파일로 저장한 경우에 파일을 문자열로 변환하지 않고 그대로 던질 수 있어서 IoT 보드에서 센서 데이터를 CSV로 저장한 경우에 사용하면 좋습니다.</p>

            <h4 @click="toggleCollapsed('csv_howto')"  class="cursor-pointer border-top border-bottom pt-2 pb-2">
              0. 주소와 데이터 형식
              <b-badge  class="float-right fontSizeDot9 cursor-pointer ml-2 mr-2" style="width: 1.3rem" variant="secondary" id="button_csv_howto" @click.self.stop="toggleCollapsed('csv_howto')">+</b-badge>
            </h4>
            <b-collapse id="collapse_csv_howto">
              <p>아두이노나 다른 IoT 기기에서 데이터를 업로딩할 주소는 다음과 같습니다. 주소가 ad가 아니라 adc로 끝납니다.</p>
              <p class="bg-secondary-lighter p-2" style="overflow : hidden">{{this.functionsServer + "/app/adc"}}</p>
              <p>이 방식은 HTTP 메시지의 본문 전체에 CSV 형식의 텍스트 파일이 들어가므로 acode, sensor와 같은 인자는 URL의 일부로 들어갑니다. 예를 들어 {{this.functionsServer + "/app/adc?acode=<i>[접속코드]</i>&sensor=<i>[센서이름]</i>"}}와 같은 형식입니다. 다음은 URL에 들어가는 인자의 목록입니다.</p>
              <ul class="mr-4">
                <li><b>acode</b>: 필수. 문자열. 접속 코드입니다. 이 기기의 접속 코드는<i>{{this.acode}}</i>입니다.</li>
                <li><b>sensor</b>: 필수. 문자열. 데이터를 추가할 센서의 이름입니다.</li>
                <li><b>response</b>: 선택. 문자열. 응답을 어떤 형식으로 받을 지 여부. number 또는 json. 기본값은 json.</li>
                <li><b>rowDelimiter</b>: 선택. 문자열. CSV 데이터의 줄을 나누는 구분자입니다. 기본값은 \n입니다. \n은 URL의 일부로 인코딩하면 %0A입니다.</li>
                <li><b>cellDelimiter</b>: 선택. 문자열. CSV 데이터의 칸을 나누는 구분자입니다. 기본값은 ,입니다. ,는 URL의 일부로 인코딩하면 %2C입니다.</li>
              </ul>
              <p>
                HTTP POST는 전통적으로 application/x-www-form-urlencoded Mime Type으로 지정한 key=value 형식으로 데이터를 전송하지만 이 방식은 텍스트 형식으로 데이터를 본문 전체로 보내는 것이므로 MIME 타입은 text/plain을 사용합니다.
              </p>
              <p>
                분문으로 보내는 텍스트는 다음과 같은 형식으로 되어 있습니다. 아래 형식에서는 rowDelimiter로는 줄바꿈인 \n을, cellDelimiter로는 ,를 사용했습니다.
                DT값은 센서에서 데이터를 측정한 시간으로 유닉스 시간입니다. 그리니치(UTC) 기준으로 1970년 1월 1일 0시 0분 0초부터 몇 초를 경과했는 지를 나타내는 정수입니다.
                DT값으로 "YYYY-MM-DDTHH:mm:ss.sss±HH:mm"와 같은 문자열 형식을 사용할 수는 없습니다.
              </p>
              <pre class="bg-secondary-lighter p-2">
[DT값],[값1],[값1]...,[값N]
[DT값],[값1],[값1]...,[값N]
[DT값],[값1],[값1]...,[값N]
[DT값],[값1],[값1]...,[값N]
[DT값],[값1],[값1]...,[값N]
[DT값],[값1],[값1]...,[값N]
</pre>
            </b-collapse>
            <div v-for="(item, index, position) in pageDeviceSensorsFiltered" :key="item.id"  class="mt-4">
              <h4 @click="toggleCollapsed('csv_' + item.name)"  class="cursor-pointer border-top border-bottom pt-2 pb-2">
                {{position+1}}. {{item.title}} ({{item.name}})
                <b-badge class="float-right fontSizeDot9 cursor-pointer ml-2 mr-2" style="width: 1.3rem" variant="secondary" :id="'button_csv_' + item.name" @click.self.stop="toggleCollapsed('csv_' + item.name)">+</b-badge>
              </h4>
              <b-collapse :id="'collapse_csv_' + item.name">
                <p>
                  그럼 먼저 데이터를 보낼 URL을 만들어봅시다.
                  <b-button size="sm" class="pt-dot1 pb-dot1 fontSizeDot9" style="vertical-align: top !important" variant="primary"
                  @click="makeUploadData('csv_url', item.name)">
                  1단계: 전송 주소 만들기
                </b-button> 버튼을 누르면 전송할 주소가 아래에 만들어집니다.
                </p>
                <div class="mr-2 ml-2 mt-1 mb-2">
                  <b-form-textarea v-touch:swipe.stop rows="3" v-model="toSend['csv_url_' + item.name]" max-rows="20"></b-form-textarea>
                </div>
                <p>
                  위의 주소에서 %0A는 \n을 인코딩한 값, %2C는 ,를 인코딩한 값입니다. 그럼 이제 전송할 데이터를 한번 만들어 봅시다.
                  <b-button size="sm" class="pt-dot1 pb-dot1 fontSizeDot9" style="vertical-align: top !important" variant="primary"
                  @click="makeUploadData('csv', item.name)">
                  2단계: 전송 데이터 만들기
                  </b-button> 버튼을 누르면 전송할 데이터가 아래에 생성됩니다.
                  {{item.name}} 센서는 값이 {{item.values.length}} 개입니다. 각 줄의 맨 처음에 데이터 저장 시간을 나타내는 dt 값이 들어가므로 각 줄에는 {{item.values.length}}+1개의 값이 들어갑니다. 데이터 값은 타입, 최소값, 최대값에 맞게
                  임의로 생성됩니다.
                </p>
                <p>
                  응답의 형식을 지정하는 response는 number나 json이 가능합니다.
                  없으면 number를 기본값으로 사용합니다.
                  아래 데이터를 직접 수정하셔도 됩니다. 1단계 전송주소에서 rowDelimiter, cellDelimiter를 수정한 경우에는 아래 데이터에서도 구분자를 수정해야합니다.
                </p>
                <div class="mr-2 ml-2 mt-1 mb-2">
                  <b-form-textarea v-touch:swipe.stop rows="3" v-model="toSend['csv_' + item.name]" max-rows="20"></b-form-textarea>
                </div>
                <p>
                  모든 준비가 끝났으면 이제 서버로 데이터를 전송합니다.
                  <b-button size="sm" style="padding: 0.2ex 1ex 0.2ex 1ex" variant="primary"
                  @click="makeRequest('csv', item.name)">
                  3단계: 서버로 데이터 업로딩하기
                  </b-button>버튼을 누르면
                  {{toSend['csv_url_' + item.name]}} 주소로
                  Content-Type 요청 헤더는 text/plain으로 설정하고
                  본문은 위의 텍스트 입력 상자로 해서 POST 방식으로 요청을 보냅니다.
                  아래는 그 실행 결과입니다.
                </p>
                <p class="bg-secondary-lighter p-2" >{{toSend['csv_result_' + item.name]}}</p>
              </b-collapse>
          </div>
        </b-card-text>
      </b-tab>

      </b-tabs>
    </b-card>



  </div>
</template>
<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { db } from "@/plugins/firebase.js"

import uiUtil from "@/mixins/util.js"
import mapUtil from "@/mixins/mapUtil.js"
import user from "@/mixins/user.js"
import functions from "@/mixins/functions.js"

import deviceTabs from "@/components/device/deviceTabs.vue"

export default {
  name: "deviceUpload",
  mixins: [uiUtil, mapUtil, user, functions],
  props: {
    pageUser: Object,
    pageDevice: Object,
    pageDeviceBinded: Boolean,
  },
  components: {
    deviceTabs,
  },
  data: function() {
    return {
      serial: null,
      acode: null,
      pageDeviceSensorsFiltered: {},
      toSend: {},
    }
  },
  created: function() {
    firebase.auth().onAuthStateChanged(() => {
      if(firebase.auth().currentUser != null) {
        this.getAcode()

        for(var item in this.pageDeviceSensorsFiltered) {
          this.$set(this.toSend, "form_" + this.pageDevice.sensors[item].name, "")
          this.$set(this.toSend, "form_result_" + this.pageDevice.sensors[item].name, "실행결과 없음")
          this.$set(this.toSend, "get_" + this.pageDevice.sensors[item].name, "")
          this.$set(this.toSend, "get_result_" + this.pageDevice.sensors[item].name, "실행결과 없음")
          this.$set(this.toSend, "json_" + this.pageDevice.sensors[item].name, "")
          this.$set(this.toSend, "json_result_" + this.pageDevice.sensors[item].name, "실행결과 없음")
          this.$set(this.toSend, "json_list_" + this.pageDevice.sensors[item].name, "")
          this.$set(this.toSend, "json_list_result_" + this.pageDevice.sensors[item].name, "실행결과 없음")
          this.$set(this.toSend, "csv_url_" + this.pageDevice.sensors[item].name, "")
          this.$set(this.toSend, "csv_" + this.pageDevice.sensors[item].name, "")
          this.$set(this.toSend, "csv_result_" + this.pageDevice.sensors[item].name, "실행결과 없음")
        }
        this.$set(this.toSend, "jsons", "")
        this.$set(this.toSend, "jsons_result", "실행결과 없음")
        this.$set(this.toSend, "jsons_list", "")
        this.$set(this.toSend, "jsons_list_result", "실행결과 없음")
      }
    })
  },
  mounted: function() {
    for(let sensor in this.pageDevice.sensors) {
      let valuesLength = this.pageDevice.sensors[sensor].values.filter(value=>{ if(!value.hold) return true; return false; }).length;
      if(valuesLength > 0) {
        this.pageDeviceSensorsFiltered[sensor]= this.pageDevice.sensors[sensor];
      }
    }
  },
  methods: {
    makeRequest: function(type, sensor) {
      if(type == "form") {
        this.toSend["form_result_" + sensor] = "실행결과 없음";
        if(this.toSend["form_" + this.pageDevice.sensors[sensor].name] == "") {
          this.makeToast("danger", "서버 업로딩 실패", "서버로 데이터를 업로딩하기 전에 [1단계: 전송 데이터 만들기] 버튼을 눌러주세요.");
          return;
        }
        else if(this.toSend["form_" + this.pageDevice.sensors[sensor].name].split("\n").length > 2) {
          this.makeToast("danger", "서버 업로딩 실패", "서버로 데이터를 업로딩하기 전에 [2단계: 값을 인코딩한 후에 &로 연결하기] 버튼을 눌러 주세요.");
          return;
        }
        this.post(this.functionsServer + "/app/ad", this.toSend["form_" + this.pageDevice.sensors[sensor].name])
        .then(result=> {
          if(result.status != 200) {
            this.makeToast("danger", "서버 업로딩 실패", "서버로 데이터 업로딩 중에 에러가 발생했습니다. 상태 코드: " + result.status + ", 상태 메시지: " + result.statusText);
          }
          else {
            if(result.headers["content-type"].indexOf("text/plain") != -1) {
              if(result.data == "1") {
                this.makeToast("success", "서버 업로딩 성공", "서버로 데이터를 업로딩 했습니다.");
              }
              else {
                this.makeToast("success", "서버 업로딩 실패", "서버로 데이터를 업로드했으나 에러가 났습니다. 자세한 에러 내용은 로그 탭을 참고하세요.");
              }
            }
            else {
              if(result.data.success) {
                this.makeToast("success", "서버 업로딩 성공", "서버로 데이터를 업로딩 했습니다.");
              }
              else {
                this.makeToast("success", "서버 업로딩 실패", "서버로 데이터를 업로드했으나 에러가 났습니다. 응답값:" + JSON.stringify(result.data));
              }
            }
            this.toSend["form_result_" + sensor] = JSON.stringify(result.data);
          }
        })
        .catch(error => {
          this.makeToast("danger", "서버 업로딩 실패", "서버로 요청을 보내지 못했습니다. error: " + error)
        })
      }
      if(type == "get") {
        this.toSend["get_result_" + sensor] = "실행결과 없음"
        if(this.toSend["get_" + this.pageDevice.sensors[sensor].name] == "") {
          this.makeToast("danger", "서버 업로딩 실패", "서버로 데이터를 업로딩하기 전에 [1단계: 전송 주소 만들기] 버튼을 눌러주세요.")
          return
        }
        this.get(this.toSend["get_" + this.pageDevice.sensors[sensor].name])
        .then(result=> {
          if(result.status != 200) {
            this.makeToast("danger", "서버 업로딩 실패", "서버로 데이터 업로딩 중에 에러가 발생했습니다. 상태 코드: " + result.status + ", 상태 메시지: " + result.statusText)
          }
          else {
            if(result.headers["content-type"].indexOf("text/plain") != -1) {
              if(result.data == "1") {
                this.makeToast("success", "서버 업로딩 성공", "서버로 데이터를 업로딩 했습니다.")
              }
              else {
                this.makeToast("success", "서버 업로딩 실패", "서버로 데이터를 업로드했으나 에러가 났습니다. 자세한 에러 내용은 로그 탭을 참고하세요.")
              }
            }
            else {
              if(result.data.success) {
                this.makeToast("success", "서버 업로딩 성공", "서버로 데이터를 업로딩 했습니다.");
              }
              else {
                this.makeToast("success", "서버 업로딩 실패", "서버로 데이터를 업로드했으나 에러가 났습니다. 응답값:" + JSON.stringify(result.data));
              }
            }
            this.toSend["form_result_" + sensor] = JSON.stringify(result.data)
          }
        })
        .catch(error => {
          this.makeToast("danger", "서버 업로딩 실패", "서버로 요청을 보내지 못했습니다. error: " + error)
        })
      }
      else if(type == "json") {
        this.toSend["json_result_" + sensor] = "실행결과 없음"
        if(this.toSend["json_" + this.pageDevice.sensors[sensor].name] == "") {
          this.makeToast("danger", "서버 업로딩 실패", "서버로 데이터를 업로딩하기 전에 [1단계: 전송 데이터 만들기] 버튼을 눌러주세요.")
          return
        }
        this.postJSON(this.functionsServer + "/app/ad", this.toSend["json_" + this.pageDevice.sensors[sensor].name])
        .then(result=> {
          if(result.status != 200) {
            this.makeToast("danger", "서버 업로딩 실패", "서버로 데이터 업로딩 중에 에러가 발생했습니다. 상태 코드: " + result.status + ", 상태 메시지: " + result.statusText)
          }
          else {
            if(result.headers["content-type"].indexOf("text/plain") != -1) {
              if(result.data == "1") {
                this.makeToast("success", "서버 업로딩 성공", "서버로 데이터를 업로딩 했습니다.")
              }
              else {
                this.makeToast("success", "서버 업로딩 실패", "서버로 데이터를 업로드했으나 에러가 났습니다. 자세한 에러 내용은 로그 탭을 참고하세요.")
              }
            }
            else {
              if(result.data.success) {
                this.makeToast("success", "서버 업로딩 성공", "서버로 데이터를 업로딩 했습니다.");
              }
              else {
                this.makeToast("success", "서버 업로딩 실패", "서버로 데이터를 업로드했으나 에러가 났습니다. 응답값:" + JSON.stringify(result.data));
              }
            }
            this.toSend["json_result_" + sensor] = JSON.stringify(result.data)
          }
        })
        .catch(error => {
          this.makeToast("danger", "서버 업로딩 실패", "서버로 요청을 보내지 못했습니다. error: " + error)
        })
      }
      else if(type == "csv") {
        this.toSend["csv_result_" + sensor] = "실행결과 없음"
        if(this.toSend["csv_url_" + this.pageDevice.sensors[sensor].name] == "") {
          this.makeToast("danger", "서버 업로딩 실패", "서버로 데이터를 업로딩하기 전에 [1단계: 전송 주소 만들기] 버튼을 눌러주세요.")
          return
        }
        if(this.toSend["csv_" + this.pageDevice.sensors[sensor].name] == "") {
          this.makeToast("danger", "서버 업로딩 실패", "서버로 데이터를 업로딩하기 전에 [2단계: 전송 데이터 만들기] 버튼을 눌러주세요.")
          return
        }
        this.postText(this.toSend["csv_url_" + this.pageDevice.sensors[sensor].name], this.toSend["csv_" + this.pageDevice.sensors[sensor].name])
        .then(result=> {
          if(result.status != 200) {
            this.makeToast("danger", "서버 업로딩 실패", "서버로 데이터 업로딩 중에 에러가 발생했습니다. 상태 코드: " + result.status + ", 상태 메시지: " + result.statusText)
          }
          else {
            if(result.headers["content-type"].indexOf("text/plain") != -1)
            {
              if(result.data == "1")
              {
                this.makeToast("success", "서버 업로딩 성공", "서버로 데이터를 업로딩 했습니다.")
              }
              else
              {
                this.makeToast("success", "서버 업로딩 실패", "서버로 데이터를 업로드했으나 에러가 났습니다. 자세한 에러 내용은 로그 탭을 참고하세요. result.data:" + result.data)
              }
            }
            else
            {
              if(result.data.success) {
                this.makeToast("success", "서버 업로딩 성공", "서버로 데이터를 업로딩 했습니다.");
              }
              else {
                this.makeToast("success", "서버 업로딩 실패", "서버로 데이터를 업로드했으나 에러가 났습니다. 응답값:" + JSON.stringify(result.data));
              }
            }
            this.toSend["csv_result_" + sensor] = JSON.stringify(result.data)
          }
        })
        .catch(error => {
          this.makeToast("danger", "서버 업로딩 실패", "서버로 요청을 보내지 못했습니다. error: " + error)
        })
      }
      else if(type == "jsons") {
        this.toSend["jsons_result"] = "실행결과 없음"
        if(this.toSend["jsons"] == "") {
          this.makeToast("danger", "서버 업로딩 실패", "서버로 데이터를 업로딩하기 전에 [1단계: 전송 데이터 만들기] 버튼을 눌러주세요.")
          return
        }
        this.postJSON(this.functionsServer + "/app/ads", this.toSend["jsons"])
        .then(result=> {
          if(result.status != 200) {
            this.makeToast("danger", "서버 업로딩 실패", "서버로 데이터 업로딩 중에 에러가 발생했습니다. 상태 코드: " + result.status + ", 상태 메시지: " + result.statusText)
          }
          else {
            console.log(result.data)
            if(result.headers["content-type"].indexOf("text/plain") != -1) {
              if(result.data == "1") {
                this.makeToast("success", "서버 업로딩 성공", "서버로 데이터를 업로딩 했습니다.")
              }
              else {
                this.makeToast("success", "서버 업로딩 실패", "서버로 데이터를 업로드했으나 에러가 났습니다. 자세한 에러 내용은 로그 탭을 참고하세요.")
              }
            }
            else {
              if(result.data.success) {
                this.makeToast("success", "서버 업로딩 성공", "서버로 데이터를 업로딩 했습니다.");
              }
              else {
                this.makeToast("success", "서버 업로딩 실패", "서버로 데이터를 업로드했으나 에러가 났습니다. 응답값:" + JSON.stringify(result.data));
              }
            }
            this.toSend["jsons_result"] = JSON.stringify(result.data)
          }
        })
        .catch(error => {
          this.makeToast("danger", "서버 업로딩 실패", "서버로 요청을 보내지 못했습니다. error: " + error)
        })
      }
      else if(type == "jsons_list") {
        this.toSend["jsons_list_result"] = "실행결과 없음"
        if(this.toSend["jsons_list"] == "") {
          this.makeToast("danger", "서버 업로딩 실패", "서버로 데이터를 업로딩하기 전에 [1단계: 전송 데이터 만들기] 버튼을 눌러주세요.")
          return
        }
        this.postJSON(this.functionsServer + "/app/ads", this.toSend["jsons_list"])
        .then(result=> {
          if(result.status != 200) {
            this.makeToast("danger", "서버 업로딩 실패", "서버로 데이터 업로딩 중에 에러가 발생했습니다. 상태 코드: " + result.status + ", 상태 메시지: " + result.statusText)
          }
          else {
            if(result.headers["content-type"].indexOf("text/plain") != -1) {
              if(result.data == "1") {
                this.makeToast("success", "서버 업로딩 성공", "서버로 데이터를 업로딩 했습니다.")
              }
              else {
                this.makeToast("success", "서버 업로딩 실패", "서버로 데이터를 업로드했으나 에러가 났습니다. 자세한 에러 내용은 로그 탭을 참고하세요.")
              }
            }
            else {
              if(result.data.success) {
                this.makeToast("success", "서버 업로딩 성공", "서버로 데이터를 업로딩 했습니다.");
              }
              else {
                this.makeToast("success", "서버 업로딩 실패", "서버로 데이터를 업로드했으나 에러가 났습니다. 응답값:" + JSON.stringify(result.data));
              }
            }
            this.toSend["jsons_list_result"] = JSON.stringify(result.data)
          }
        })
        .catch(error => {
          this.makeToast("danger", "서버 업로딩 실패", "서버로 요청을 보내지 못했습니다. error: " + error)
        })
      }
      else if(type == "json_list") {
        this.toSend["json__list_result_" + sensor] = "실행결과 없음"
        if(this.toSend["json_list_" + this.pageDevice.sensors[sensor].name] == "") {
          this.makeToast("danger", "서버 업로딩 실패", "서버로 데이터를 업로딩하기 전에 [1단계: 여러 개의 전송 데이터 만들기] 버튼을 눌러주세요.")
          return
        }
        this.postJSON(this.functionsServer + "/app/ad", this.toSend["json_list_" + this.pageDevice.sensors[sensor].name])
        .then(result=> {
          if(result.status != 200) {
            this.makeToast("danger", "서버 업로딩 실패", "서버로 데이터 업로딩 중에 에러가 발생했습니다. 상태 코드: " + result.status + ", 상태 메시지: " + result.statusText)
          }
          else {
            if(result.headers["content-type"].indexOf("text/plain") != -1) {
              if(result.data == "1") {
                this.makeToast("success", "서버 업로딩 성공", "서버로 데이터를 업로딩 했습니다.")
              }
              else {
                this.makeToast("success", "서버 업로딩 실패", "서버로 데이터를 업로드했으나 에러가 났습니다. 자세한 에러 내용은 로그 탭을 참고하세요.")
              }
            }
            else {
              if(result.data.success) {
                this.makeToast("success", "서버 업로딩 성공", "서버로 데이터를 업로딩 했습니다.");
              }
              else {
                this.makeToast("success", "서버 업로딩 실패", "서버로 데이터를 업로드했으나 에러가 났습니다. 응답값:" + JSON.stringify(result.data));
              }
            }
            this.toSend["json_list_result_" + sensor] = JSON.stringify(result.data)
          }
        })
        .catch(error => {
          this.makeToast("danger", "서버 업로딩 실패", "서버로 요청을 보내지 못했습니다. error: " + error)
        })
      }
    },

    toggleCollapsed: function(id) {
      if(window.document.getElementById("button_" + id).innerText == "+") {
        window.document.getElementById("button_" + id).innerText = "-"
      }
      else {
        window.document.getElementById("button_" + id).innerText = "+"
      }
      this.$root.$emit("bv::toggle::collapse", "collapse_" + id)
    },

    makeEncodedData: function(type, sensor) {
      if(this.toSend["form_" + this.pageDevice.sensors[sensor].name] == "") {
        this.makeToast("danger", "데이터 인코딩 실패", "먼저 1단계: 전송 데이터 만들기 버튼을 누르세요.")
        return
      }
      var str = ""
      if(type == "form") {
        var todo = this.toSend["form_" + this.pageDevice.sensors[sensor].name].split("\n")
        if(todo.length == 1) {
          this.makeToast("danger", "데이터 인코딩 실패", "2단계: 값을 인코딩한 후에 &로 연결하기 버튼은 1번만 눌러주세요.")
          return
        }
        for(var i=0;i<todo.length;i++) {
          var pos = todo[i].indexOf("=")
          if(pos != -1) {
            var key = encodeURIComponent(todo[i].slice(0, pos))
            var value = encodeURIComponent(todo[i].slice(pos+1, todo[i].length))
            str += key + "=" + value + "&"
          }
        }
        str=str.slice(0,str.length-1)
        this.toSend["form_" + this.pageDevice.sensors[sensor].name] = str
      }
    },

    makeUploadData: function(type, sensor) {
      var str = ""
      var i, j
      if(type == "form") {
        str += "acode=" + this.acode + "\n"
        str += "sensor=" + this.pageDevice.sensors[sensor].name + "\n"
        str+= (this.makeRandomInt(0,1) == 0)
          ? "dt=" + parseInt(Date.now()/1000) + "\n"
          : "dtstr=" + this.toISOString(new Date()) + "\n"
        str+= (this.makeRandomInt(0,1) == 0)
          ? "response=number\n"
          : "response=json\n"

        this.pageDeviceSensorsFiltered[sensor].values
        .filter(value=>{
          if(value.hold) return false;
          return true;
        })
        .forEach((value,index)=>{
          str += value.name + "=" + this.makeRandomValue(value.type, value.min, value.max) + "\n"
        });

        this.toSend["form_" + this.pageDevice.sensors[sensor].name] = str
      }
      else if(type == "get") {
        str += this.functionsServer + "/app/ad" + "?acode=" + encodeURIComponent(this.acode) + "&"
        str += "sensor=" + encodeURIComponent(this.pageDevice.sensors[sensor].name)
        str+= (this.makeRandomInt(0,1) == 0)
          ? "&dt=" + encodeURIComponent(parseInt(Date.now()/1000))
          : "&dtstr=" + encodeURIComponent(this.toISOString(new Date()))
        str+= (this.makeRandomInt(0,1) == 0)
          ? "&response=number"
          : "&response=json"

        this.pageDeviceSensorsFiltered[sensor].values
        .filter(value=>{
          if(value.hold) return false;
          return true;
        })
        .forEach((value,index)=>{
          str += "&" + encodeURIComponent(value.name) + "=" + encodeURIComponent(this.makeRandomValue(value.type, value.min, value.max))
        });

        this.toSend["get_" + this.pageDevice.sensors[sensor].name] = str
      }
      else if(type == "json") {
        str += "{\n"
        str += "\t\"acode\": \"" + this.acode + "\",\n"
        str += "\t\"sensor\": \"" + this.pageDevice.sensors[sensor].name + "\",\n"
        str += (this.makeRandomInt(0,1) == 0)
          ? "\t\"response\": \"number\",\n"
          : "\t\"response\": \"json\",\n"
        str += "\t\"values\": { "
        str+= (this.makeRandomInt(0,1) == 0)
          ? "\"dt\": " + parseInt(Date.now()/1000) + ", "
          : "\"dtstr\": \"" + this.toISOString(new Date()) + "\", "


        this.pageDeviceSensorsFiltered[sensor].values
        .filter(value=>{
          if(value.hold) return false;
          return true;
        })
        .forEach((value,index)=>{
          if(index != 0) str += ", ";
          if(value.type == "string") {
            str += "\"" + value.name + "\": \"" + this.makeRandomValue(value.type, value.min, value.max) + "\"";
          }
          else {
            str += "\"" + value.name + "\": " + this.makeRandomValue(value.type, value.min, value.max);
          }
        });

        str += " }\n"
        str += "}\n"
        this.toSend["json_" + this.pageDevice.sensors[sensor].name] = str
      }
      else if(type == "jsons") {
        str += "{\n"
        str += "\t\"acode\": \"" + this.acode + "\",\n"
        str += (this.makeRandomInt(0,1) == 0)
          ? "\t\"response\": \"number\",\n"
          : "\t\"response\": \"json\",\n"
        str += "\t\"sensors\": [\n"

        for(var sensor in this.pageDeviceSensorsFiltered) {
          str += "\t\t{\n"
          str += "\t\t\t\"sensor\": \"" + this.pageDeviceSensorsFiltered[sensor].name + "\",\n"
          str += "\t\t\t\"values\": { "
          str+= (this.makeRandomInt(0,1) == 0)
            ? "\"dt\": " + parseInt(Date.now()/1000) + ", "
            : "\"dtstr\": \"" + this.toISOString(new Date()) + "\", "


          this.pageDeviceSensorsFiltered[sensor].values
          .filter(value=>{
            if(value.hold) return false;
            return true;
          })
          .forEach((value,index)=>{
            if(index != 0) str += ", ";
            if(value.type == "string") {
              str += "\"" + value.name + "\": \"" + this.makeRandomValue(value.type, value.min, value.max) + "\""
            }
            else {
              str += "\"" + value.name + "\": " + this.makeRandomValue(value.type, value.min, value.max)
            }
          });
          str += " }\n"
          str += "\t\t},\n"
        }
        str = str.substring(0, str.length - 2)
        str += "\n"
        str += "\t]\n"
        str += "}\n"
        this.toSend["jsons"] = str
      }

      else if(type == "csv") {
        // str += "\t\"acode\": \"" + this.acode + "\",\n"
        // str += "\t\"sensor\": \"" + this.pageDevice.sensors[sensor].name + "\",\n"
        //str += (this.makeRandomInt(0,1) == 0)
        //  ? "\t\"response\": \"number\",\n"
        //  : "\t\"response\": \"json\",\n"

        //str += "\t\"values\": [\n"

        let repeat = this.makeRandomInt(1,5)
        let seedDate = parseInt(Date.now()/1000);

        for(j=0;j<repeat;j++) {
          str += (seedDate-repeat+j) + ",";

          this.pageDevice.sensors[sensor].values.filter(value=>{
            if(value.hold) return false;
            return true;
          })
          .forEach((value,index)=>{
            if(index != 0) str += ",";
            str += this.makeRandomValue(value.type, value.min, value.max);
          });
          if(j!=(repeat-1)) str += "\n";
        }
        this.toSend["csv_" + this.pageDevice.sensors[sensor].name] = str
      }

      else if(type == "csv_url") {
        str += this.functionsServer + "/app/adc?"
        str += "acode=" + this.acode
        str += "&sensor=" + this.pageDevice.sensors[sensor].name
        str+= (this.makeRandomInt(0,1) == 0)
          ? "&response=number"
          : "&response=json\n"
        str+= "&rowDelimiter=" + encodeURIComponent("\n")
        str+= "&cellDelimiter=" + encodeURIComponent(",")
        this.toSend["csv_url_" + this.pageDevice.sensors[sensor].name] = str
      }
      // bingo
      else if(type == "json_list") {
        str += "{\n"
        str += "\t\"acode\": \"" + this.acode + "\",\n"
        str += "\t\"sensor\": \"" + this.pageDevice.sensors[sensor].name + "\",\n"
        str += (this.makeRandomInt(0,1) == 0)
          ? "\t\"response\": \"number\",\n"
          : "\t\"response\": \"json\",\n"
        str += "\t\"values\": [\n"

        let repeat = this.makeRandomInt(1,5);
        let dateType = this.makeRandomInt(0,1);
        let seedDate = parseInt(Date.now()/1000);

        for(j=0;j<repeat;j++) {
          str += "\t\t{"
          str+= (dateType == 0)
            ? " \"dt\": " + (seedDate-repeat+j) + ", "
            : " \"dtstr\": \"" + this.toISOString(new Date((seedDate-repeat+j)*1000)) + "\", "

          this.pageDevice.sensors[sensor].values.filter(value=>{
            if(value.hold) return false;
            return true;
          })
          .forEach((value,index)=>{
            if(index != 0) str += ", ";
            if(value.type == "string") {
              str += "\"" + value.name + "\": \"" + this.makeRandomValue(value.type, value.min, value.max) + "\"";
            }
            else {
              str += "\"" + value.name + "\": " + this.makeRandomValue(value.type, value.min, value.max);
            }
          });

          if(j!=(repeat-1)) str += " },\n";
          else str += " }\n";
        }

        str += "\t]\n"
        str += "}\n"
        this.toSend["json_list_" + this.pageDevice.sensors[sensor].name] = str
      }
      // bingo
      else if(type == "jsons_list") {
        str += "{\n"
        str += "\t\"acode\": \"" + this.acode + "\",\n"
        str += (this.makeRandomInt(0,1) == 0)
          ? "\t\"response\": \"number\",\n"
          : "\t\"response\": \"json\",\n"
        str += "\t\"sensors\": [\n"

        for(var sensor in this.pageDeviceSensorsFiltered) {
          str += "\t\t{\n"
          str += "\t\t\t\"sensor\": \"" + this.pageDeviceSensorsFiltered[sensor].name + "\",\n"
          str += "\t\t\t\"values\": [\n"

          let repeat = this.makeRandomInt(1,5);
          let dateType = this.makeRandomInt(0,1);
          let seedDate = parseInt(Date.now()/1000);

          for(j=0;j<repeat;j++) {
            str += "\t\t\t\t{";
            str+= (dateType == 0)
              ? " \"dt\": " + (seedDate-repeat+j) + ", "
              : " \"dtstr\": \"" + this.toISOString(new Date((seedDate-repeat+j)*1000)) + "\", ";

            this.pageDeviceSensorsFiltered[sensor].values.filter(value=>{
              if(value.hold) return false;
              return true;
            })
            .forEach((value,index)=>{
              if(index != 0) str += ", ";
              if(value.type == "string") {
                str += "\"" + value.name + "\": \"" + this.makeRandomValue(value.type, value.min, value.max) + "\"";
              }
              else {
                str += "\"" + value.name + "\": " + this.makeRandomValue(value.type, value.min, value.max)
              }
            });

            if(j!=(repeat-1)) str += " },\n";
            else str += " }\n";
          }
          str += "\t\t\t]\n";
          str += "\t\t},\n";
        }
        str = str.substring(0, str.length - 2)
        str += "\n"
        str += "\t]\n"
        str += "}\n"
        this.toSend["jsons_list"] = str
      }
    },

    getAcode: function() {
      db.collection("acodes").where("device", "==", this.pageDevice.id).where("owner", "==", this.pageUser.id)
      .get()
      .then(acodeList => {
        acodeList.forEach(acode => {
          if(acode.exists) {
            this.serial = acode.data().serial
            this.acode = acode.id
          }
        })
      })
      .catch(error => {
        this.makeToast("danger", "접속 코드 조회 실패", "접속 코드 조회 중에 에러가 발생했습니다. 에러 내용:" + error)
      })
    },
  },
}
</script>
